import { TenantActions, ETenantActions } from '../actions/tenant.actions';
import { TenantState, initialTenantState } from '../states/tenant.state';

export function tenantReducers(
  state = initialTenantState,
  action: TenantActions
): TenantState {
  switch (action.type) {
    case ETenantActions.GetTenantSuccess: {
      return {
        ...state,
        tenant: action.payload
      };
    }

    case ETenantActions.GetTenantFailure: {
      return {
        ...state,
        tenant: null
      };
    }

    default:
      return state;
  }
}
